import React from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { jobs } from '../data/jobs';


const JobsPage: React.FC = () => {
  const [selectedJob, setSelectedJob] = React.useState<string | null>(null);
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    phone: '',
    position: '',
    message: '',
    cv: null as File | null,
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFormData(prev => ({ ...prev, cv: e.target.files![0] }));
    }
  };

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  const formPayload = new FormData();
  formPayload.append('name', formData.name);
  formPayload.append('email', formData.email);
  formPayload.append('phone', formData.phone);
  formPayload.append('position', formData.position);
  formPayload.append('message', formData.message);
  if (formData.cv) {
    formPayload.append('cv', formData.cv);
  }

  try {
    
    const response = await fetch('https://masahillshealthservices.com/api/job.php', {
      method: 'POST',
      body: formPayload,
      headers: {
        'Accept': 'application/json',
      },
    });

    const result = await response.json();

    if (response.ok && result.success) {
      toast.success('Application submitted successfully!', {
        duration: 4000,
        position: 'top-center',
        style: {
          background: '#10B981',
          color: '#fff',
          borderRadius: '10px',
          padding: '16px',
        },
      });
      setFormData({
        name: '',
        email: '',
        phone: '',
        position: '',
        message: '',
        cv: null,
      });
    } else {
      throw new Error(result.error || 'Failed to send application');
    }
  } catch (error) {
    toast.error(`Error sending application: ${error}`, {
      duration: 4000,
      position: 'top-center',
      style: {
        background: '#EF4444',
        color: '#fff',
        borderRadius: '10px',
        padding: '16px',
      },
    });
  }
};

  return (
    <div className="min-h-screen bg-gradient-to-br from-lightGrey via-teal-100 to-blue-100 relative overflow-hidden">
      {/* Add Toaster component at the root level */}
      <Toaster />
      {/* Animated Background Blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-coral/20 to-yellow/20 rounded-full animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-teal/20 to-blue/20 rounded-full animate-blob animation-delay-2000"></div>
        <div className="absolute top-40 left-1/2 w-60 h-60 bg-gradient-to-br from-magenta/20 to-coral/20 rounded-full animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative z-10 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16 animate-float">
            <div className="inline-block p-6 bg-white/80 backdrop-blur-sm rounded-3xl shadow-2xl mb-8">
              <h1 className="text-5xl md:text-6xl font-bold mb-4 font-heading">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-coral via-magenta to-teal">
                  Join Our Team
                </span>
              </h1>
              <p className="text-xl text-darkBlue/80 max-w-3xl mx-auto leading-relaxed">
                We're looking for passionate individuals to help us deliver exceptional home care services that make a real difference in people's lives.
              </p>
            </div>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Jobs List - Now showing coming soon message */}
            <div className="lg:col-span-2 space-y-6">
              <div className="flex items-center mb-8">
                <h2 className="text-3xl font-bold text-darkBlue font-heading">Current Openings</h2>
                <div className="ml-4 h-1 flex-1 bg-gradient-to-r from-coral to-teal rounded-full"></div>
              </div>
              
              {/* Coming Soon Message */}
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg p-12 text-center border border-white/50">
                <div className="text-8xl mb-6">🚀</div>
                <h3 className="text-3xl font-bold text-darkBlue mb-4 font-heading">
                  New Opportunities Coming Soon!
                </h3>
                <p className="text-darkBlue/70 text-lg mb-6 leading-relaxed">
                  We're currently updating our job openings and will be posting new positions very soon. 
                  We're always looking for passionate healthcare professionals to join our team.
                </p>
                <div className="bg-gradient-to-r from-teal/10 to-coral/10 rounded-xl p-6 mb-6">
                  <h4 className="text-xl font-semibold text-darkBlue mb-3">Interested in joining our team?</h4>
                  <p className="text-darkBlue/70 mb-4">
                    Feel free to reach out to us with your resume and let us know about your experience and interests. 
                    We'll keep your information on file for future opportunities.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                    <div className="flex items-center text-darkBlue/70">
                      <svg className="h-5 w-5 mr-2 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      <span>contact@masahillshealthservices.com</span>
                    </div>
                    <div className="flex items-center text-darkBlue/70">
                      <svg className="h-5 w-5 mr-2 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                      <span>(469) 573-0176</span>
                    </div>
                  </div>
                </div>
                <button
                  className="inline-flex items-center px-8 py-3 rounded-full text-lg font-semibold text-white bg-gradient-to-r from-coral to-magenta hover:from-magenta hover:to-coral transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                  onClick={() => document.getElementById('application-form')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Submit Your Resume
                  <svg className="ml-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Application Form */}
            <div className="lg:sticky lg:top-8 h-fit">
              <div 
                id="application-form"
                className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-white/50"
              >
                <div className="bg-gradient-to-r from-coral via-magenta to-teal px-8 py-6">
                  <h2 className="text-2xl font-bold text-white font-heading">
                    Submit Your Resume
                  </h2>
                </div>
                
                <div className="p-8">
                  <div className="space-y-6">
                    <div>
                      <label htmlFor="position" className="block text-sm font-semibold text-darkBlue mb-2">
                        Position of Interest
                      </label>
                      <select
                        id="position"
                        name="position"
                        value={formData.position}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border-2 border-teal/20 rounded-xl focus:ring-4 focus:ring-teal/20 focus:border-teal transition-all duration-300 bg-white/70 text-darkBlue"
                      >
                        <option value="">Select a position of interest</option>
                        <option value="Caregiver">Caregiver</option>
                        <option value="Certified Nursing Assistant (CNA)">Certified Nursing Assistant (CNA)</option>
                        <option value="Care Coordinator">Care Coordinator</option>
                        <option value="Administrative Assistant">Administrative Assistant</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    
                    <div>
                      <label htmlFor="name" className="block text-sm font-semibold text-darkBlue mb-2">
                        Full Name
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border-2 border-teal/20 rounded-xl focus:ring-4 focus:ring-teal/20 focus:border-teal transition-all duration-300 bg-white/70 text-darkBlue"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="email" className="block text-sm font-semibold text-darkBlue mb-2">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border-2 border-teal/20 rounded-xl focus:ring-4 focus:ring-teal/20 focus:border-teal transition-all duration-300 bg-white/70 text-darkBlue"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="phone" className="block text-sm font-semibold text-darkBlue mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className="w-full px-4 py-3 border-2 border-teal/20 rounded-xl focus:ring-4 focus:ring-teal/20 focus:border-teal transition-all duration-300 bg-white/70 text-darkBlue"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="message" className="block text-sm font-semibold text-darkBlue mb-2">
                        Cover Letter (Optional)
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        rows={4}
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder="Tell us about your experience and why you're interested in joining our team..."
                        className="w-full px-4 py-3 border-2 border-teal/20 rounded-xl focus:ring-4 focus:ring-teal/20 focus:border-teal transition-all duration-300 bg-white/70 text-darkBlue resize-none"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="cv" className="block text-sm font-semibold text-darkBlue mb-2">
                        Upload Resume/CV (PDF, max 5MB)
                      </label>
                      <div className="relative">
                        <label className="cursor-pointer group">
                          <div className="flex items-center justify-center w-full px-4 py-6 border-2 border-dashed border-teal/30 rounded-xl hover:border-teal hover:bg-teal/5 transition-all duration-300">
                            <div className="text-center">
                              {formData.cv ? (
                                <span className="text-teal font-medium">{formData.cv.name}</span>
                              ) : (
                                <>
                                  <svg className="mx-auto mb-2 h-8 w-8 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                  </svg>
                                  <span className="block text-darkBlue/70">Click to upload or drag & drop</span>
                                  <span className="block text-xs text-darkBlue/40 mt-1">PDF only, max 5MB</span>
                                </>
                              )}
                            </div>
                            <input
                              type="file"
                              id="cv"
                              name="cv"
                              accept=".pdf"
                              className="absolute inset-0 opacity-0 cursor-pointer"
                              onChange={handleFileChange}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                  
                  <button
                    type="submit"
                    className="w-full mt-6 py-3 rounded-xl bg-gradient-to-r from-coral to-teal text-white font-bold text-lg shadow-lg hover:from-teal hover:to-coral transition-all duration-300"
                    onClick={handleSubmit}
                  >
                    Submit Resume
                  </button>
                </div>
              </div>

              {/* Benefits Section */}
              <div className="mt-8 bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-white/50">
                <div className="bg-gradient-to-r from-blue via-teal to-coral px-8 py-6">
                  <h2 className="text-2xl font-bold text-white font-heading">Why Work With Us</h2>
                </div>
                <div className="p-8">
                  <div className="space-y-6">
                    {[
                      'Competitive salaries and comprehensive benefits',
                      'Flexible working arrangements and remote options',
                      'Ongoing training and professional development',
                      'Supportive team environment and mentorship',
                      'Meaningful work making a real difference'
                    ].map((benefit, index) => (
                      <div key={index} className="flex items-start group">
                        <div className="flex-shrink-0">
                          <div className="w-6 h-6 bg-gradient-to-r from-teal to-coral rounded-full flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
                            <svg className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                            </svg>
                          </div>
                        </div>
                        <span className="text-darkBlue font-medium leading-relaxed group-hover:text-coral transition-colors duration-300">
                          {benefit}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobsPage;